import { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';

const StyledAudio = styled.audio`
  cursor: pointer;
  width: 100%;
  height: 50px;
`;

interface AudioPlayerProps {
  src: AudioResponse | File | null;
}

function AudioPlayer({ src }: AudioPlayerProps) {
  const ref = useRef<null | HTMLVideoElement>(null);
  const [audioPreview, setAudioPreview] = useState<string | undefined>();

  useEffect(() => {
    if (!src) {
      setAudioPreview(undefined);
      return;
    }

    if (src instanceof File) {
      setAudioPreview(URL.createObjectURL(src));
      return;
    }

    setAudioPreview(src.url ?? undefined);
  }, [src]);

  return <StyledAudio src={audioPreview} ref={ref} loop controls />;
}

export default AudioPlayer;
